/*
|--------------------------------------------------------------------------
| Views: Video Article NDN
|--------------------------------------------------------------------------
*/

/**
 * Video Article
 * @namespace
 */
__gh__webApp.views.videoArticleNDN = {

	"callbacks": function(bucket){
		__gh__webApp.video.ndn.init();
	},

	"getSubView": function(bucket){
		var thirdPartyData 	= __gh__coreData["3rdPartyData"],
			commonJS		= __gh__webApp.common,
			items			= bucket.items.main,
			killBucket		= false;


		if (!commonJS.isObjectPropertySet(items[0], "category")){
			return killBucket;
		}


		// Get the NDN data needed to load player
		var ndnObject		= __gh__webApp.video.ndn,
			ndnVideo		= items[0],
			ndnData			= ndnObject.getData(ndnVideo.category);

		bucket.view.name 	= "buckets/videoArticleNDN/default";
		bucket.view.ndn 	= ndnData;
		return bucket;
	}
};
